export default __webpack_public_path__ + "static/media/Medium.cfd7d905.svg";